import React from 'react';
import { Link } from 'react-router-dom';
import SocialIcon from './SocialIcon';
import { LOGO_URL, SOCIAL_LINKS, CONTACT_INFO } from '../data';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer style={{ background:'#0a0a0a', color:'rgba(255,255,255,.65)', padding:0 }}>

      {/* Top accent line */}
      <div style={{ height:3, background:'linear-gradient(90deg,#E8315B,#7B52AB,#4BB8E8)' }}/>

      <div style={{ padding:'72px 0 0' }}>
        <div className="container">
          <div className="ft-grid">

            {/* Brand column */}
            <div>
              <Link to="/" style={{ display:'inline-block', marginBottom:20 }}>
                <img
                  src={LOGO_URL}
                  alt="ITClave — Best IT Company India"
                  style={{
                    height:48,
                    width:'auto',
                    display:'block',
                    /* keep transparent PNG looking crisp on dark bg */
                    filter:'brightness(1)',
                  }}
                />
              </Link>
              <p style={{ fontSize:'.86rem', lineHeight:1.82, color:'rgba(255,255,255,.38)', marginBottom:22, maxWidth:260 }}>
                India's trusted software development and digital marketing company.
                World-class digital solutions for startups, SMEs and enterprises since 2018.
              </p>
              {/* Social icons */}
              <div style={{ display:'flex', gap:8, flexWrap:'wrap', marginBottom:24 }}>
                {SOCIAL_LINKS.map(s => (
                  <SocialIcon key={s.icon} icon={s.icon} url={s.url} name={s.name} size={34} radius={9}/>
                ))}
              </div>
              {/* Mini stats */}
              <div style={{ display:'flex', gap:20, flexWrap:'wrap' }}>
                {[['200+','Projects'],['4.9★','Rating'],['150+','Clients'],['6+','Years']].map(([n,l])=>(
                  <div key={l} style={{ textAlign:'center' }}>
                    <div style={{ fontFamily:"'Outfit',sans-serif", fontWeight:900, fontSize:'1.15rem', background:'linear-gradient(90deg,#E8315B,#7B52AB,#4BB8E8)', WebkitBackgroundClip:'text', WebkitTextFillColor:'transparent', backgroundClip:'text', lineHeight:1 }}>{n}</div>
                    <div style={{ fontSize:'.65rem', color:'rgba(255,255,255,.32)', fontWeight:600, textTransform:'uppercase', letterSpacing:'.06em', marginTop:2 }}>{l}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* Services */}
            <div>
              <div className="ft-h4">Services</div>
              <ul className="ft-ul">
                {['Web Development','Digital Marketing','Mobile App Dev','SEO Services','UI/UX Design','Custom Software','Cloud & DevOps','E-Commerce'].map(s=>(
                  <li key={s}><Link to="/services">{s}</Link></li>
                ))}
              </ul>
            </div>

            {/* Company */}
            <div>
              <div className="ft-h4">Company</div>
              <ul className="ft-ul">
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/portfolio">Portfolio</Link></li>
                <li><Link to="/team">Our Team</Link></li>
                <li><Link to="/products">Products</Link></li>
                <li><Link to="/blog">Blog</Link></li>
                <li><Link to="/careers">Careers</Link></li>
                <li><Link to="/careers#internship">Internship</Link></li>
              </ul>
            </div>

            {/* Contact */}
            <div>
              <div className="ft-h4">Get In Touch</div>
              <ul className="ft-ul" style={{ marginBottom:20 }}>
                <li>
                  <a href={`tel:+917808707393`} style={{ display:'flex', alignItems:'center', gap:8 }}>
                    <span style={{ fontSize:'.9rem' }}>📞</span>
                    <span>{CONTACT_INFO.phone}</span>
                  </a>
                </li>
                <li>
                  <a href={`mailto:${CONTACT_INFO.email}`} style={{ display:'flex', alignItems:'center', gap:8 }}>
                    <span style={{ fontSize:'.9rem' }}>✉️</span>
                    <span>{CONTACT_INFO.email}</span>
                  </a>
                </li>
                <li>
                  <Link to="/contact" style={{ display:'flex', alignItems:'center', gap:8 }}>
                    <span style={{ fontSize:'.9rem' }}>📍</span>
                    <span>{CONTACT_INFO.address}</span>
                  </Link>
                </li>
                <li style={{ marginTop:8 }}>
                  <a href={CONTACT_INFO.whatsapp} style={{ color:'#4ade80', fontWeight:700, display:'flex', alignItems:'center', gap:8 }}>
                    <span style={{ fontSize:'.9rem' }}>💬</span> WhatsApp Us
                  </a>
                </li>
                <li>
                  <Link to="/contact" style={{ color:'#c4b5fd', fontWeight:700, display:'flex', alignItems:'center', gap:8 }}>
                    <span style={{ fontSize:'.9rem' }}>📋</span> Get Free Quote
                  </Link>
                </li>
              </ul>

              {/* Cities served */}
              <div className="ft-h4" style={{ marginBottom:10 }}>We Serve</div>
              <div style={{ display:'flex', flexWrap:'wrap', gap:6 }}>
                {['Delhi','Mumbai','Bangalore','Hyderabad','Pune','Chennai','Kolkata','Ahmedabad'].map(c=>(
                  <span key={c} style={{ background:'rgba(255,255,255,.06)', border:'1px solid rgba(255,255,255,.09)', borderRadius:100, padding:'3px 10px', fontSize:'.7rem', color:'rgba(255,255,255,.42)', fontWeight:600 }}>📍 {c}</span>
                ))}
              </div>
            </div>
          </div>

          {/* Bottom bar */}
          <div className="ft-bot">
            <div className="ft-copy">
              © {year}&nbsp;<span style={{ color:'#c4b5fd', fontWeight:700 }}>ITClave</span>. All rights reserved.&nbsp;
              India's Trusted Software Development &amp; Digital Marketing Company.
            </div>
            <div style={{ display:'flex', gap:18 }}>
              {['Privacy Policy','Terms of Service','Sitemap'].map(l=>(
                <a
                  key={l}
                  href="#"
                  style={{ fontSize:'.75rem', color:'rgba(255,255,255,.24)', transition:'color .3s' }}
                  onMouseOver={e=>{ e.target.style.color='rgba(255,255,255,.6)'; }}
                  onMouseOut={e=>{  e.target.style.color='rgba(255,255,255,.24)'; }}
                >{l}</a>
              ))}
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .ft-grid{display:grid;grid-template-columns:2fr 1fr 1fr 1.3fr;gap:48px;padding-bottom:56px;border-bottom:1px solid rgba(255,255,255,.06)}
        .ft-h4{font-family:'Outfit',sans-serif;font-weight:800;font-size:.78rem;color:rgba(255,255,255,.9);text-transform:uppercase;letter-spacing:.1em;margin-bottom:18px}
        .ft-ul{list-style:none;display:flex;flex-direction:column;gap:11px}
        .ft-ul a{font-size:.84rem;color:rgba(255,255,255,.36);transition:all .3s;display:inline-block}
        .ft-ul a:hover{color:rgba(255,255,255,.8);padding-left:6px}
        .ft-bot{padding:24px 0;display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:12px}
        .ft-copy{font-size:.78rem;color:rgba(255,255,255,.2)}
        @media(max-width:1024px){.ft-grid{grid-template-columns:1fr 1fr}}
        @media(max-width:640px){.ft-grid{grid-template-columns:1fr}.ft-bot{flex-direction:column;text-align:center}}
      `}</style>
    </footer>
  );
}
